import { Injectable } from '@angular/core';

import { CalendarEvent, CalendarTimeFormat } from '../calendar.models';

import { CalendarEventLayout } from './calendar-event-layout.model';

@Injectable()
export class CalendarDayViewLayoutService {
  getTimeline(
    timeFormat: CalendarTimeFormat = CalendarTimeFormat['12H'],
    timeScale: number,
    workingHours: { min: number; max: number },
  ): string[] {
    const timeline: string[] = [];

    for (let i = workingHours.min; i <= workingHours.max; i += timeScale) {
      const date = new Date();
      date.setHours(Math.floor(i), 60 * (i - Math.floor(i)), 0);
      let formatted = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        ...(timeScale === 1 ? {} : { minute: 'numeric' }),
        hourCycle: timeFormat === CalendarTimeFormat['12H'] ? 'h12' : 'h23',
      })
        .format(date)
        .toLocaleLowerCase()
        .replaceAll(' ', '');

      if (formatted.startsWith('0')) {
        formatted = formatted.slice(1);
      }

      timeline.push(formatted);
    }

    return timeline;
  }

  positionEvents(events: CalendarEvent[]): CalendarEventLayout[] {
    const layoutEvents: CalendarEventLayout[] = events
      .sort(this.sortByDate)
      .map((event) => new CalendarEventLayout(event));

    let lastEventEnding: number | null = null;
    let columns: CalendarEventLayout[][] = [];

    for (const layoutEvent of layoutEvents) {
      if (lastEventEnding && layoutEvent.event.startDate.getTime() >= lastEventEnding) {
        this.updatePosition(columns);
        columns = [];
        lastEventEnding = null;
      }

      let placed = false;

      for (const column of columns) {
        if (!column[column.length - 1].collidesWith(layoutEvent)) {
          column.push(layoutEvent);
          placed = true;
          break;
        }
      }

      if (!placed) {
        columns.push([layoutEvent]);
      }

      if (!lastEventEnding || layoutEvent.event.endDate.getTime() > lastEventEnding) {
        lastEventEnding = layoutEvent.event.endDate.getTime();
      }
    }

    if (columns.length > 0) {
      this.updatePosition(columns);
    }

    return layoutEvents;
  }

  private updatePosition(groups: CalendarEventLayout[][]): void {
    let columnIdx = 0;
    for (const columns of groups) {
      for (const event of columns) {
        event.setPosition(columnIdx, groups.length);
      }
      columnIdx++;
    }
  }

  private sortByDate(a: CalendarEvent, b: CalendarEvent): number {
    if (a.startDate.getTime() < b.startDate.getTime()) {
      return -1;
    }
    if (a.startDate.getTime() > b.startDate.getTime()) {
      return 1;
    }
    if (a.endDate.getTime() < b.endDate.getTime()) {
      return -1;
    }
    if (a.endDate.getTime() < b.endDate.getTime()) {
      return 1;
    }

    return 0;
  }
}
